import { useState } from 'react'
import { useLocation } from 'wouter'
import { SearchList01Icon } from '@hugeicons/core-solid-rounded'
import { useLingui } from '@lingui/react/macro'
import { GraphQL } from '@guestgoodie/graphql'

import Input from '@/components/ui/Input'
import { AddButton } from '@/components/ui/IconButton'
import { SpaceTable } from './SpaceTable'
import { SyncButton, useIsPmsConnected } from '@/features/integrations'
import { Permission, useCheckPermission } from '@/features/auth'

export function Spaces() {
  const { t } = useLingui()
  const [, navigate] = useLocation()

  const isConnected = useIsPmsConnected()
  const hasPermissionToCreate = useCheckPermission([Permission.SPACE_CREATE])
  const canCreate = !isConnected && hasPermissionToCreate

  const [search, setSearch] = useState<string>('')

  return (
    <div>
      <div className="flex flex-col md:flex-row gap-2.5 pb-6 pt-1 items-start md:items-center">
        {canCreate && (
          <AddButton
            onClick={() => navigate('/create-space')}
            aria-label={t`Create Room`}
          />
        )}
        <SyncButton type={GraphQL.SyncableObject.Rooms} />
        <Input
          Icon={SearchList01Icon}
          placeholder={t`Search…`}
          value={search}
          onChange={event => setSearch(event.target.value)}
        />
      </div>
      <div className="relative w-full rounded bg-white p-5 flex-1 overflow-hidden flex flex-col">
        <div className="size-full overflow-y-auto inset-0">
          <SpaceTable search={search} />
        </div>
      </div>
    </div>
  )
}
